import { NavLink } from 'react-router';

import { ROUTES } from '@/constants/routes';
import { orgPath } from '@/utils/org-path';
import { useOrgStore } from '@/stores/org-store';
import { useLaunchDarkly } from '@/providers/launchdarkly-provider';
import { KeysList } from './keys-list';

export const CapitolKeysPage = () => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid || '';
  const { isUserApiTokensEnabled } = useLaunchDarkly();

  return (
    <div className='flex flex-col gap-6 w-full mb-10'>
      <KeysList
        title='Capitol API keys'
        description='Manage and create API keys to connect with Capitol AI securely. Give each key a clear name (and description if you’d like) so it’s easy to track and organize your integrations.'
      />
      {/* Only surface the cross-link when the tokens page is actually reachable
          (same flag guards the /settings/api-tokens route), so admins don't
          land on FeatureGuard's NotFound page while the feature is off. */}
      {isUserApiTokensEnabled && (
        <p className='text-sm text-muted-foreground'>
          Looking for personal API tokens for the Upload API? See{' '}
          <NavLink
            to={orgPath(ROUTES.ACCOUNT.API_TOKENS, orgId)}
            className='font-medium text-foreground underline underline-offset-2 hover:no-underline'
          >
            Settings → API tokens
          </NavLink>
          .
        </p>
      )}
    </div>
  );
};
